export const RDCModalHTML = ({ side }) => {
  const titles = {
    front: "Front side",
    back: "Back side",
  }
 const title = titles[side]
  return (
    <div className="rdc-modal-container">
      <div className="rdc-rotate-overlay" style={{ display: "none" }}>
        <div className="rdc-rotate-content">
          <svg className="rdc-rotate-icon" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="3" width="20" height="14" rx="2" />
            <path d="M8 21h8M12 17v4" />
          </svg>
          <h2 className="rdc-rotate-title">Please rotate your device</h2>
          <p className="rdc-rotate-message">Turn your device to landscape mode to capture the check</p>
        </div>
      </div>
      <div className="rdc-modal-content">
        <div className="rdc-video-container">
          <div className="rdc-modal-title">
            {title}
          </div>
          <video className="rdc-video" autoPlay playsInline></video>
          <div className="rdc-guide-container">
            <div className="rdc-guide-frame">
              <div className="rdc-guide-corners rdc-corner-top-left"></div>
              <div className="rdc-guide-corners rdc-corner-top-right"></div>
              <div className="rdc-guide-corners rdc-corner-bottom-left"></div>
              <div className="rdc-guide-corners rdc-corner-bottom-right"></div>
            </div>
          </div>
          <div className="rdc-bottom-text">
            Make sure that the corners of the check are inside the frame
          </div>
        </div>
        <canvas className="rdc-canvas"></canvas>
        <div className="rdc-capture-button-container">
          <button className="rdc-capture-button"></button>
        </div>
        <div className="rdc-loading" style={{ display: "none" }}>
          <div className="rdc-spinner"></div>
        </div>
        <p className="rdc-error" style={{ display: "none" }}></p>
      </div>
    </div>
  );
};